import { renderFullGaranSvg, renderNestedGaranSvg } from './garan-label-artwork'

export interface GaranLabel {
  duration: string,
  manufacturer: string,
  modelIdentifier: string
}

/**
 * Shopware shows the GARAN label only for a commercial durability guarantee
 * longer than 24 months, in half-year steps. The storefront attribute
 * `garantie` stores labels such as "20 Jahre Hersteller-Garantie Wohnen".
 */
export function formatGaranDuration (guaranteeLabel: string): string | null {
  if (!guaranteeLabel) return null
  const match = String(guaranteeLabel).match(/(\d+(?:[.,]\d+)?)\s*Jahre?/i)
  if (!match) return null

  const years = Number(match[1].replace(',', '.'))
  if (!isFinite(years)) return null

  const months = Math.round(years * 12)
  if (months <= 24 || months % 6 !== 0) return null

  const fullYears = Math.floor(months / 12)
  if (months % 12 === 0) return String(fullYears)
  return fullYears + ',5'
}

function optionLabel (attributesByCode, code: string, rawValue): string {
  if (rawValue == null || rawValue === '') return ''

  const attribute = attributesByCode ? attributesByCode[code] : null
  const values = Array.isArray(rawValue) ? rawValue : String(rawValue).split(',')

  if (!attribute || !attribute.options) {
    return typeof rawValue === 'string' && /[A-Za-zÄÖÜäöü]/.test(rawValue) ? rawValue : ''
  }

  const labels = []
  for (let i = 0; i < values.length; i++) {
    const value = values[i]
    let found = ''
    const options = attribute.options
    for (let j = 0; j < options.length; j++) {
      if (String(options[j].value) === String(value).trim()) {
        found = options[j].label
        break
      }
    }
    if (found) labels.push(found)
  }
  return labels.join(', ')
}

function producerName (label: string): string {
  if (!label) return ''
  return String(label).split(',')[0].replace(/\s+/g, ' ').trim()
}

export function resolveGaranLabel (product, attributesByCode): GaranLabel | null {
  if (!product) return null

  const duration = formatGaranDuration(optionLabel(attributesByCode, 'garantie', product.garantie))
  const manufacturer = producerName(optionLabel(attributesByCode, 'manufacturer', product.manufacturer))
  const modelIdentifier = String(product.sku_extern || product.sku || '').trim()

  if (!duration || !manufacturer || !modelIdentifier) return null

  return { duration, manufacturer, modelIdentifier }
}

export function nestedGaranMarkup (label: GaranLabel, uid: string): string {
  return renderNestedGaranSvg(label.duration, uid)
}

export function fullGaranMarkup (label: GaranLabel, uid: string): string {
  return renderFullGaranSvg(label, uid)
}
